import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

import { PUBLIC_DATADOG_DEV_ENABLED } from '@lib/constants'
import { useAppSelector } from '@store/hooks'
import { selectCurrentUser } from '@store/modules/session/slice'

/* 
  Add user info to Datadog
  
  Example: 
  useAnalytics()
*/
export const useAnalytics = () => {
  const session = useAppSelector(selectCurrentUser)

  useEffect(() => {
    if (!PUBLIC_DATADOG_DEV_ENABLED) {
      return
    }

    const name =
      session?.first_name || session?.last_name
        ? `${session.first_name ?? ''} ${session.last_name ?? ''}`.trim()
        : undefined

    if (session) {
      if (datadogRum.getInitConfiguration()) {
        datadogRum.setUser({
          id: String(session.id),
          email: session.email,
          name,
          role: session.role,
        })
      }
    } else {
      if (datadogRum.getInitConfiguration()) {
        datadogRum.setUser({})
      }
    }
  }, [session])
}
